module.exports = __webpack_public_path__ + "static/images/p4.415dc22.png";